import * as React from 'react';
import { UIText1 } from '@cian/ui-kit/typography';

export const InfoText = () => {
  return (
    <div>
      <UIText1>
        Вам позвонят наиболее подходящие риэлторы. Им покажем другой номер телефона, который перенаправит звонок на ваш.
      </UIText1>
    </div>
  );
};

InfoText.displayName = 'InfoText';
